class NewsletterTeaser extends window.BAO.CustomElement() {
  constructor () {
    super()

    if (!window.BAO.MediaBreakpoints.isMd) return

    this.submittedStorageName = 'BAO-newsletter-submitted-popup'
    this.teaserClosedStorageName = 'BAO-newsletter-teaser-closed'
    this.isCustomer = this.dataset.customer
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.openTeaser = this.openTeaser.bind(this)
    this.listeners.add(window, 'load', this.openTeaser)

    this.closeTeaser = this.closeTeaser.bind(this)
    this.listeners.add(this.els.close.element, 'click', this.closeTeaser)
  }

  closeTeaser () {
    window.localStorage.setItem(this.teaserClosedStorageName, true)

    this.setAttribute('aria-hidden', 'true')
  }

  openTeaser () {
    if (!this.shouldShowTeaser()) return

    this.setAttribute('aria-hidden', 'false')
  }

  shouldShowTeaser () {
    let shouldShow = true

    // Don't show if teaser has been closed
    if (window.localStorage.getItem(this.teaserClosedStorageName) !== null) {
      shouldShow = false
    }

    // Don't show if popup has already been submitted
    if (window.localStorage.getItem(this.submittedStorageName) !== null) {
      shouldShow = false
    }

    // Don't show if already logged in
    if (this.isCustomer === 'true') shouldShow = false

    return shouldShow
  }
}

if (!customElements.get('newsletter-teaser')) {
  customElements.define('newsletter-teaser', NewsletterTeaser)
}
